import { useSnackbar } from 'notistack';

export const useCopyToClipboard = () => {
  const { enqueueSnackbar } = useSnackbar();

  const copyToClipboard = (value: string) => {
    navigator.clipboard
      .writeText(value)
      .then(() => enqueueSnackbar('Successfully copied to clipboard', { variant: 'success' }))
      .catch(() => enqueueSnackbar('Failed to copy to clipboard', { variant: 'error' }));
  };
  return copyToClipboard;
};
